import axios from "@/plugins/axios";

let url = "/api/v1/users";

export default {
    post(data) {
        return axios.post(url, data).then((result) => result.data);
    },
    postBusinessCert(file) {
        const headers = { "Content-Type": "multipart/form-data" };
        const formData = new FormData();
        formData.append("file", file);
        return axios.post(`${url}/business-cert`, formData, { headers }).then((result) => result.data);
    },
    certify(data) {
        return axios.post(`${url}/certify`, data).then((result) => result.data);
    },
    recovery(data) {
        return axios.post(`${url}/recovery`, data).then((result) => result.data);
    },
};
